import { provideZoneChangeDetection } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideRouter } from '@angular/router';
import { provideIonicAngular } from '@ionic/angular/standalone';
import { AppComponent } from './app/app.component';
import { routes } from './app/app.routes';
import { GRAPHQL_API_URL } from './app/services/graphql.tokens';
import { getWorkerGraphqlUrl } from './worker-url';

bootstrapApplication(AppComponent, {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideIonicAngular({ mode: 'md' }),
    { provide: GRAPHQL_API_URL, useValue: getWorkerGraphqlUrl() },
  ],
});
